<template>
  <div class="creators">
    <BaseHero>
      <div class="hero-body has-text-centered">
        <h1 class="title">CREATORS</h1>
        <h2 class="subtitle">
          View the current Gaming Iluminaughty roster below
        </h2>
      </div>
    </BaseHero>
    <section class="creators-wrapper container" style="margin-top:3rem">
      <div class="columns is-multiline">
        <div
          v-for="member of sortArrays(giData)"
          :key="member.id"
          class="column is-4"
          data-aos="fade-in"
        >
          <article class="">
            <header>
              <div
                class="card-hero"
                :style="{
                  'background-image':
                    'linear-gradient(to bottom, rgba(13, 12, 16, .25) 0%, rgba(13, 12, 16, 1) 80%), url(' +
                    member.avatar +
                    ')',
                }"
              ></div>
            </header>
            <main>
              <br />
              <center>
                <div class="image">
                  <img
                    v-if="member.avatar"
                    :src="member.avatar"
                    width="100px"
                  />
                  <img
                    v-else
                    src="@/assets/avatars/default.jpg"
                    width="100px"
                  />
                </div>
                <br />
                <h1 class="title" style="margin-bottom: 0rem">
                  {{ member.name }}
                </h1>
                <h1 class="title">
                  <span style="font-size: 1rem;">{{
                    member.realName || "---"
                  }}</span>
                </h1>
                <p style="text-align: justify; flex-grow: 1">
                  {{ member.bio }}
                </p>
              </center>
              <br />
            </main>
            <footer class="has-text-centered">
              <h1 class="title">
                <span style="font-size: 1rem;">
                  Social Links
                </span>
              </h1>
              <div class="buttons has-text-centered">
                <b-tooltip
                  v-if="member.twitter"
                  :label="member.twitter"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.twitter"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-twitter"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.instagram"
                  :label="member.instagram"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.instagram"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.instagram2"
                  :label="member.instagram2"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.instagram2"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-instagram"></i>
                  </a>
                </b-tooltip>
                <!-- <b-tooltip
                  v-if="member.facebook"
                  :label="member.facebook"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.facebook"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-facebook"></i>
                  </a>
                </b-tooltip> -->
                <b-tooltip
                  v-if="member.youtube"
                  :label="member.youtube"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.youtube"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-youtube"></i>
                  </a>
                </b-tooltip>

                <b-tooltip
                  v-if="member.youtube2"
                  :label="member.youtube2"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.youtube2"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-youtube"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.twitch"
                  :label="member.twitch"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.twitch"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-twitch"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.patreon"
                  :label="member.patreon"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.patreon"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fab fa-patreon"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.podcast"
                  :label="member.podcast"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.podcast"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fas fa-podcast"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.music"
                  :label="member.music"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.music"
                    target="_blank"
                    class="button social-btn "
                  >
                    <i class="fas fa-music"></i>
                  </a>
                </b-tooltip>
                <b-tooltip
                  v-if="member.sz"
                  :label="member.sz"
                  position="is-bottom"
                  :animated="true"
                >
                  <a
                    :href="member.sz"
                    target="_blank"
                    class="button social-btn "
                  >
                    <img src="@/assets/sz-icon.svg" width="20px" alt="" />
                  </a>
                </b-tooltip>
              </div>
            </footer>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseHero from "@/components/BaseHero";
export default {
  name: "Contact",
  components: { BaseHero },
  data() {
    return {
      giData: undefined,
      bgImage: {
        backgroundImage: "",
      },
    };
  },
  mounted() {
    this.getAirTableData();
  },
  methods: {
    async getAirTableData() {
      this.axios({
        url: "https://api.airtable.com/v0/appDFYQTsodbFxpmH/GI%20Members",
        headers: {
          Authorization: `Bearer ${process.env.VUE_APP_AIRTABLE_API_KEY}`,
        },
      })
        .then((res) => {
          let data = [];
          res.data.records.forEach((member) => {
            data.push(member.fields);
          });
          this.giData = data;
          return;
        })
        .catch(() => {
          return;
        });
    },
    sortArrays(arrays) {
      return this.lodash.orderBy(arrays, "id", "asc");
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}
@media only screen and (max-width: 43.75em) {
  .creators-wrapper {
    padding: 0.5rem;
  }
}
$gi-card-border-radius: 4px;
.creators {
  min-height: 100vh;
  text-align: left;
}
.container {
  overflow: visible;
}
article {
  margin-top: 2rem;
  background: #0d0c10;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border: 1px solid rgb(129, 102, 50);
  text-align: left;
  color: #acacac;
  font-size: 1.1rem;
  min-height: 625px;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  &:hover {
    box-shadow: rgba(129, 102, 50, 0.4) 3px 3px, rgba(129, 102, 50, 0.3) 8px 8px,
      rgba(129, 102, 50, 0.2) 13px 13px;
    header {
      filter: grayscale(0%);
    }
  }
  header {
    overflow: hidden;
    filter: grayscale(100%);
    transition: all 0.2s ease-in-out;
    .card-hero {
      transform: scale(1.05);
      height: 16rem;
      background: linear-gradient(250deg, #d5be78 0%, #a1753a 100%);
      background-size: cover;
      background-position: center;
      filter: blur(10px) saturate(200%);
      margin: -5px -10px -10px -5px;
      border-bottom: 1px solid coral;
    }
  }
  main {
    cursor: default;
    user-select: none;
    padding: 1.25rem;
    flex: 1;
    .title {
      background: linear-gradient(250deg, #d5be78 0%, #a1753a 100%);
      background-clip: text;
      -webkit-text-fill-color: transparent;
      font-weight: 900 !important;
      letter-spacing: 0.075rem;
      font-size: 2.25rem;
    }
    img {
      margin-top: -14rem;
      width: 200px;
      border-top-left-radius: 20px;
      border-bottom-right-radius: 20px;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
        rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
      border: 1px solid #0d0c10;
    }
    .buttons {
      justify-self: end;
    }
  }
  footer {
    border-top: 2px solid darken($color: #bf9c5a, $amount: 20);
    padding-top: 0rem;
    padding-bottom: 1rem;
    .title {
      margin-top: 0rem;
      background: linear-gradient(250deg, #d5be78 0%, #a1753a 100%);
      background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-bottom: 0.5rem;
      user-select: none;
    }
    .buttons {
      margin-top: 0;
    }
  }
}
.media-content {
  padding: 1rem;
}
.button.social-btn {
  background: linear-gradient(250deg, #d5be78 0%, #a1753a 100%);
  border: none;
  border-radius: 6px !important;
  &.is-outlined {
    background: none;
    color: #d5be78;
    border: 1px solid #d5be78;
  }
}

.b-tooltip {
  margin-right: 0.5rem;
}
</style>
